import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    dark: false,
    options: {
      customProperties: true,
    },
    themes: {
      light: {
        primary: '#41B883',
        secondary: '#2C2654',
      },
      dark: {
        primary: '#2C2654',
      },
    },
  },
});
